<template>
	<div
		:class="[cellData != null ? 'data-set' : '',hidden ? 'hidden-cell' : '']"
		:style="{ ...cellStyle(), ...cellWidth }"
		@click="openCellDialog"
		v-text="cellText()"
	>
	</div>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	props: {
		cell: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		coordinate: {
			type: Object,
			required: false,
			default: () => ({
				xCoordinate: {
					type: Number,
					required: true,
				},
				yCoordinate: {
					type: Number,
					required: true,
				},
			}),
		},
		columnWidth: {
			type: Number,
			required: false,
			default: 104,
		},
		hidden:{
			type: Boolean,
			required: false, 
			default: false,
		}
	},
	data() {
		return {
			cellData: null,
			mergeXAxis: null,
			mergeYAxis: null,
			columns: [],
		}
	},
	methods: {
		openCellDialog() {
			this.$emit("open-cell-dialog", { cell: this.cell, coordinate: this.coordinate })
		},
		cellText(){
			if (this.cellData != null){
				return this.cellData
			} else if (this.cell){
				return this.cellValue()
			}
			//  else {
			// 	return null
			// }
		},
		cellStyle() {
			const style = {}
			if (this.cell.style) {
				style.textAlign = this.cell.style.alignment?.horizontal
				style.fontSize = !this.cell.style.font?.size || this.cell.style.font?.size == 10 ? '' : `${this.cell.style.font?.size}px`
				style.fontWight = this.cell.style.font?.weight ? " bold" : ""
				style.backgroundColor = this.cellData != null ? "" : `#${this.cell.style.fill?.bgColor?.argb}`
			}
			return style
		},
		cellValue() {
			if (this.cell.value == null || this.hidden) return null
			switch (this.cell.style?.numFmt) {
				case "h:mm":
				case "[h]:mm":
					return moment.utc(this.cell.value.toISOString()).format("HH:mm")
				case "mm-dd-yy":
					return moment.utc(this.cell.value.toISOString()).format("MM/DD/YY")
				default:
					return this.cell.value
			}
		},
	},
	computed: {
		cellWidth() {
			const style = {}
			// widthに支障をきたした時のためにとりあえず置いておく
			// if (this.columns.length && this.mergeXAxis) {
			// 	const currentIndex = this.coordinate.xCoordinate
			// 	const lastIndex = currentIndex + this.mergeXAxis
			// 	let width = 0
			// 	for (let i = currentIndex; i < lastIndex; i++) {
			// 		width += this.columns[i].width || 200
			// 	}
			// 	style.width = width + "px"
			// 	style.minWidth = width + "px"
			// 	style.maxWidth = width + "px"
			// } else {
			// 	style.width = this.columnWidth + "px"
			// 	style.minWidth = this.columnWidth + "px"
			// 	style.maxWidth = this.columnWidth + "px"
			// }
			if (this.mergeXAxis && this.mergeYAxis) {
				style.gridColumnStart = this.coordinate.xCoordinate + 1
				style.gridColumnEnd = this.coordinate.xCoordinate + this.mergeXAxis + 1
				style.gridRowStart = this.coordinate.yCoordinate + 1
				style.gridRowEnd = this.coordinate.yCoordinate + this.mergeYAxis + 1
			} else if (this.mergeXAxis) {
				style.gridColumnStart = this.coordinate.xCoordinate + 1
				style.gridColumnEnd = this.coordinate.xCoordinate + this.mergeXAxis + 1
				style.gridRowStart = this.coordinate.yCoordinate + 1
				style.gridRowEnd = this.coordinate.yCoordinate + 2 
			} else if (this.mergeYAxis) {
				style.gridColumnStart = this.coordinate.xCoordinate + 1
				style.gridColumnEnd = this.coordinate.xCoordinate + 2
				style.gridRowStart = this.coordinate.yCoordinate + 1
				style.gridRowEnd = this.coordinate.yCoordinate + this.mergeYAxis + 1
			} else {
				style.gridColumnStart = null 
				style.gridColumnEnd = null 
				style.gridRowStart = null 
				style.gridRowEnd = null 
			}
			return style
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

div.data-set {
	background-color: $excel-cell-bg-color;
}
</style>